import axios from 'axios';
import crypto from '@/utils/crypto.js'

export default class Http {
  constructor(config) {
    this.config = config;
    this.http = axios.create({
      baseURL: config.baseUrl,
      headers: config.headers,
      withCredentials: true,
      timeout: config.timeout
    });
  }

  _get(uri, params) {
    return this._request(uri, 'get', params, null);
  }

  _post(uri, params, data) {
    return this._request(uri, 'post', params, data);
  }

  _put(uri, params, data) {
    return this._request(uri, 'put', params, data);
  }

  _delete(uri, params) {
    return this._request(uri, 'delete', params, null);
  }

  // _request(uri, method, params, data) {
  //   return new Promise((resolve, reject) => {
  //     this.http.request({
  //         url: uri,
  //         method: method,
  //         params: params,
  //         data: data
  //       })
  //       .then((res) => {
  //         // console.log(res)
  //         // debugger;
  //         switch (res.data.code) {
  //           case 500:
  //           // alert('服务器连接中断')
  //           case 501:
  //           case 503:
  //             reject({
  //               code: res.data.code,
  //               msg: res.data.msg
  //             });
  //             break;
  //           default:
  //             resolve(res);
  //         }
  //       })
  //       .catch((err) => {
  //         let _this = this
  //         if (err.response && err.response.status == 401) {
  //           let url = new URL(_this.config.baseUrl + '/api/Login/GetAuthorize2');
  //           url.searchParams.append('InstitutionId', _this.config.headers.CurrentInstitutionId);
  //           // url.searchParams.append('returnUrl', window.location.hash);
            
  //           url.searchParams.append('returnUrl', window.location.href);
  //           let newHref=unescape(url.href)
  //           window.location.href = newHref;
  //         }
  //         reject(err);
  //       })
  //   });
  // }


  _request(uri, method, params, data) {
    return new Promise((resolve, reject) => {
      // get不带参数
      if(method == "get" && typeof params == 'undefined'){
        params = {}

      // get带参数
      }else if(method == "get"){
        var newparams=''
        for(let key in params){
          if(params.hasOwnProperty(key)){
            newparams+= key +'='+params[key]+'&'
          }
        }
        newparams = newparams.slice(0,-1) //删除末尾的'&'符号
        uri = uri+'?version=2&data='+ crypto.wordEncrypt(newparams)
        params = {}

      // post带参数  
      }else if(method == "post"){
        var _data ={
          "version":"2",
          "data":crypto.wordEncrypt(data)
        }
        data = JSON.stringify(_data)
      }
        this.http.request({
          url: uri,
          method: method,
          params,
          data,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then((res) => {
          switch (res.data.code) {
            case 500:
            case 501:
            case 503:
              reject({
                code: res.data.code,
                msg: res.data.msg
              });
              break;
            default:
              if(typeof(res.data)!= 'object'){
                resolve(res)
              }else{
                try{data = JSON.parse(crypto.wordDecrypt(res.data.data))}
                catch(err){data = crypto.wordDecrypt(res.data.data)}
                resolve({
                  data:{
                    data,
                    msg:res.msg,
                    code:res.data.code
                  }
                });
              }
              
          }
        })
        .catch((err) => {
          let _this = this
          if (err.response && err.response.status == 401) {
            let url = new URL(_this.config.baseUrl + 'api/Login/GetAuthorize2');
                        url.searchParams.append('institutionId', _this.config.headers.CurrentInstitutionId);
                        url.searchParams.append('returnUrl', window.location.href);
                        let newHref=unescape(url.href)
                        window.location.href = newHref;
          }
          reject(err);
        })
      
    });
  }

}



// WEBPACK FOOTER //
// ./src/lib/Core/Http.js